export default __webpack_public_path__ + "static/tin_prices-3a21210eb81010b05fcd2aeaedbe983d.png";